import { TipoIstanzaFascicoloDTO } from "./tipo-istanza-fascicoloDTO";
import { ClassificaDTO } from "./classificaDTO";
import { StatoFascicoloEnum } from "../enum/stato-fascicolo-enum";
import { RiferimentiPosizioneDTO } from "./riferimento-posizioneDTO";
import { UtenteDTO } from "./utenteDTO";
import { RiferimentoEsternoDTO } from "./riferimento-esternoDTO";
import { DatiReportorioDTO } from "./dati-repertorioDTO";
import { TempiConservazioneDTO } from "./tempi-conservazioneDTO";
import { ProcedimentoDTO } from "./procedimentoDTO";
import { DatiPersonaliDTO } from "./dati-personaliDTO";
import { UnitaDocumentariaDTO } from "./unita-documentariaDTO";
import { CommentoDTO } from "./commentoDTO";
import { CampoSpecificoFascicoloDTO } from "./campo-specifico-fascicoloDTO";
import { IstanzeProcedimentoDTO } from "./istanze-procedimentoDTO";
import { VisibilitaFascicoloDTO } from "./visibilita-fascicoloDTO";
import { RiferimentoFascicoloCartaceoDTO } from "./riferimento-fascicolo-cartaceoDTO";
import { StrutturaFascicoloDTO } from "./struttura-fascicoloDTO";
import { LinguaDTO } from "./linguaDTO";
import { MetadatiRepertorioDTO } from "./metadati-repertorioDTO";
import { SettoreDTO } from "./settoreDTO";
import { IstanzaAttivitaDTO } from "./istanza-attivitaDTO";

export class FascicoloDTO {
  id: string;
  tipologia: TipoIstanzaFascicoloDTO;
  oggetto: string;
  descrizione: string;
  nome: string;
  dataCreazione: string;
  classifica: ClassificaDTO;
  classificaAggiuntiva: ClassificaDTO;
  segnaturaArchivistica: string; //es. 	A.010.020/GEN/2019/0000001
  stato: StatoFascicoloEnum;
  ibrido: boolean; // settare a true quando è presente dentro roba cartacea.
  riferimentoPosizione: RiferimentiPosizioneDTO;
  dataApertura: string;
  dataChiusura: string;
  dataAnnullamento: string;
  dataUltimaModifica: string;
  dataManuale: string;
  estremoRemoto: string;
  dataVersione: string;
  estremoRecente: string;
  creatoDa: UtenteDTO;
  strutturaResponsabile: StrutturaFascicoloDTO;
  riferimentoFascicoloEsterno: RiferimentoEsternoDTO;
  datiReportorio: DatiReportorioDTO;
  motivoEccezioneTempiConservazione: string;
  tempiConservazione: TempiConservazioneDTO;
  attivitaAssociata: IstanzaAttivitaDTO;
  datiPrivacy: DatiPersonaliDTO;
  sottoFascicoli: FascicoloDTO[];
  documenti: UnitaDocumentariaDTO[]; // fare refactor
  commenti: CommentoDTO[];
  place: string;
  riferimentoFascicoloCartaceo: RiferimentoFascicoloCartaceoDTO;
  campiSpecifici: CampoSpecificoFascicoloDTO[];
  //campiSpecificiConservazione: CampoSpecificoConservazioneDTO[];
  referenteFascicolo: UtenteDTO;
  visibilitaFascicolo: VisibilitaFascicoloDTO[];
  lingue: LinguaDTO[];
  dimensioni: number;
  altraDenominazione: string;
  contestoIstituzionale: string;
  documentazioneSeparata: boolean;
  repertoriato: boolean;
  metadatiRepertorio: MetadatiRepertorioDTO;
  struttureAggiuntive: SettoreDTO[];
  modificatoDaLinneo: boolean;
}
